import { useState } from "react";
import GLOBAL, { DoubleToDegree, timezones } from "../Common/Util";
import { axiosGetWithHeader } from "../Common/axios";
import { useNavigate } from "react-router-dom";

export function Title({title, urlcallback}) {
    const navigate = useNavigate();

    const handleBack = (event) => {
        if(urlcallback===null || urlcallback===undefined) {
            setTimeout(() => {
            navigate('/', { replace: true });
            }, 100);
        } else {
            urlcallback();
        }
      }
    
    
    return (
        <>
            <span class="h2"><button type="button" class="btn btn-outline-secondary border-0 rounded-circle p-1 ps-2 pe-2" onClick={()=>handleBack()}>&#129128;</button>{title}</span>
        </>
    );
}

export function Message({msg}) {
    return (
        <>
          <div class="h6 mt-1 small text-center text-danger" dangerouslySetInnerHTML={{__html: msg}}></div>
        </>
    );
}

export function FirstNameLastName({title, firstnamereference, lastnamereference, firstvalue, lastvalue, callback}) {
    return (
        <>
            <div class="mt-1">
                <label for={title}>{title}:</label>
            </div>
            <div class="input-group mb-3 ">
                <input type="input" maxlength="50" class="form-control" id="firstName" ref={firstnamereference} placeholder="First Name" name="firstName" value={firstvalue} onChange={callback} />
                <input type="input" maxlength="50" class="form-control" id="lastName" ref={lastnamereference} placeholder="Last Name (optional)" name="lastName" value={lastvalue} onChange={callback} />
            </div>
        </>
    );
}

export function CurrentPin({reference, data, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    return (
        <>
        <div class="">
            <label for="pin">Current Pin * :</label>
        </div>  
        <div class="input-group mb-3 ">
            <input type={showPassword ? 'text' : 'password'} maxlength="15" class="form-control" id="currentpin" ref={reference} placeholder="Enter current pin" name="currentpin" value={data} onChange={callback} />
            <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
            </span>
        </div>
        </>
    );
}

export function ConfirmPin({reference, confirmreference, value, confirmvalue, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    return (
        <>
          <div class="mt-3">
              <label for="password" title="min: 6 digit, max: 15 digit">Pin * :</label>
          </div>  
          <div class="input-group mb-3 ">
              <input type="password" maxlength="15" class="form-control" id="pin" ref={reference} placeholder="Enter pin" name="pin" value={value} onChange={callback}/>
              <input type={showPassword ? 'text' : 'password'} maxlength="15" class="form-control" id="confirmpin" ref={confirmreference} placeholder="Confirm pin" name="confirmpin" value={confirmvalue} onChange={callback}/>
              <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
              </span>
          </div>
        </>
    );
}

export function CurrentPassword({reference, data, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    return (
        <>
        <div class="">
            <label for="password">Current Password * :</label>
        </div>  
        <div class="input-group mb-3 ">
            <input type={showPassword ? 'text' : 'password'} maxlength="20" class="form-control" id="currentpassword" ref={reference} placeholder="Enter password" name="currentpassword" value={data} onChange={callback} />
            <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
              </span>
        </div>
        </>
    );
}

export function ConfirmPassword({reference, confirmreference, value, confirmvalue, callback}) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    return (
        <>
          <div class="mt-3">
              <label for="password" title="min: 8, max:20, required: 1 char, 1 digit, 1 cap, 1 special char">Password * :</label>
          </div>  
          <div class="input-group mb-3 ">
              <input type="password" maxlength="20" class="form-control" id="password" ref={reference} placeholder="Enter password" name="password" value={value} onChange={callback}/>
              <input type={showPassword ? 'text' : 'password'} maxlength="20" class="form-control" id="confirmpassword" ref={confirmreference} placeholder="Confirm password" name="confirmpassword" value={confirmvalue} onChange={callback}/>
              <span class="input-group-text" onClick={togglePasswordVisibility} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
              </span>
          </div>
        </>
    );
}

export function Input({name, title, placeholder, reference, data, callback}) {
    return (
        <div class="mb-3 mt-1">
            <label for={name}>{title}:</label>
            <input type="input" maxlength="50" class="form-control" id={name} ref={reference} placeholder={placeholder} name={name} value={data} onChange={callback}/>
        </div>
    );
}

export function Email({reference, data, callback, optional}) {
    return (
        <div class="mb-3 mt-3">
            <label for="email">Email {optional===null||optional!=="true"?"* ":""}:</label>
            <input type="input" maxlength="50" class="form-control" id="email" ref={reference} placeholder="Enter email (optional)" name="email" value={data} onChange={callback} />
        </div>
    );
}

export function Mobile({reference, data, callback, optional}) {
    return (
        <div class="mb-3 mt-3">
            <label for="mobile" title="min:10 digit, max:15 digit">Mobile {optional===null||optional!=="true"?"* ":""}:</label>
            <input type="input" maxlength="15" class="form-control" id="mobile" ref={reference} placeholder="Enter mobile (optional)" name="mobile" value={data} onChange={callback} />
        </div>
    );
}

export function MaritalStatus({name, title, reference, data, callback}) {
    return (
        <div class="mb-3 mt-1">
            <label for={name}>{title}:</label>
            <select class="form-select" id={name} name={name} ref={reference} value={data} onChange={callback}>
                <option key="" value="">Not Available</option>
                <option key="Single" value="Single">Single</option>
                <option key="Married" value="Married">Married</option>
                <option key="Divorced" value="Divorced">Divorced</option>
                <option key="Widowed" value="Widowed">Widowed</option>
                <option key="Separated" value="Separated">Separated</option>
            </select>
        </div>
    );
}

export function Timezone({name, reference, data, callback}) {
    return (
        <div class="mb-3 dropdown">
            <label for={name}>Time zone:</label>
            <select class="form-select" id={name} name={name} ref={reference} value={data} onChange={callback}>
            {timezones.map((option,index) => (
              <option key={index+"_"+option.value} value={option.value}>{option.label}</option>
            ))}
            </select>
        </div>
    );
}


export function Date({name, title, reference, data, callback}) {
    return (
        <div class="mb-3 mt-1">
            <label for={name}>{title}:</label>
            <input type="date" class="form-control" id={name} ref={reference} placeholder="dd/mm/yyyy" oninput="if(this.value.length > 10) this.value = this.value.replace(/\d{5,}/, match => match.substr(0, 4));" max="2999-12-31" name={name} value={data} onChange={callback}/>
        </div>
    );
}

export function Sex({name, title, reference, data, callback}) {
    return (
        <div class="mb-3 mt-1">
            <label for={name}>{title}:</label>
            <select class="form-select" id={name} name={name} ref={reference} value={data} onChange={callback}>
                <option key="Male" value="Male">Male</option>
                <option key="Female" value="Female">Female</option>
            </select>
        </div>
    );
}

export function DateTime({title1, title2, dateplaceholder, timeplaceholder, datereference, datename, timename, timereference, datevalue, timevalue, callback}) {
    return (
        <>
            <div class="mt-3">
                <label for="datetime">{title1}:</label>
            </div>
            <div class="input-group mb-3 ">
                <input type="date" maxlength="10" class="form-control" oninput="if(this.value.length > 10) this.value = this.value.replace(/\d{5,}/, match => match.substr(0, 4));" max="2999-12-31" id={datename} ref={datereference} placeholder={dateplaceholder} name={datename} value={datevalue} onChange={callback} style={{ 'letterSpacing':'0.5em' }} />
            </div>
            <div class="mt-3">
                <label for="datetime">{title2}:</label>
            </div>
            <div class="input-group mb-3 ">
                <input type="time" step="1" maxlength="10" class="form-control" id={timename} ref={timereference} placeholder={timeplaceholder} name={timename} value={timevalue} onChange={callback} style={{ 'letterSpacing':'1em' }}/>
            </div>
        </>
    );
}


export function LocationCoordinates({cityname, citytitle, cityreference, cityvalue, 
    coordinatesname,coordinatestitle, longitudename, latitudename, longitudereference, latitudereference, 
    longitudevalue, latitudevalue, callback, callbacklocation}) {
    const [data, setData] = useState([]);
    
    var callCommand=(event)=>{
        callback(event);
        if(event.target.value.length<3) {
            setData([]);
            onInput(event,[]);
        } else {
            axiosGetWithHeader("/search/coordinate/"+event.target.value, 
            (response)=>{
                setData(response.data);
                onInput(event, response.data);
            },
            (error)=>{
                setData([]);
                onInput(event,[]);
            }
          );
          GLOBAL.isLoading=false;
        }
    }

    var onInput=(event,data)=> {
        var val=event.target.value;
        var flag="false";
        data.map((option) => {
           if(option.locationName===val) {
                callbacklocation(longitudename,option.longitude.trim());
                callbacklocation(latitudename,option.latitude.trim());
                flag="true";
           }
           return null;
        });
        if(flag==="false"){
            callbacklocation(longitudename,'');
            callbacklocation(latitudename,'');
        }
    }
    return (
        <>
            <div class="mb-3 mt-1">
                <label for={cityname}>{citytitle}:</label>
                <input type="input" class="form-control" list="citylist" id={cityname} ref={cityreference} placeholder={citytitle} name={cityname} value={cityvalue} onChange={callCommand}/>
                <datalist id="citylist" >
                    {data.map((option) => (
                    <option key={option.locationName} value={option.locationName}>{option.locationName}</option>
                    ))}
                </datalist>
            </div>

            <div class="mt-3">
                <label for={coordinatesname}>{coordinatestitle}: ( <DoubleToDegree value={latitudevalue} /> , <DoubleToDegree value={longitudevalue}/> )</label>
            </div>
            <div class="input-group mb-3 ">
                <input type="input" maxlength="50" class="form-control" id={latitudename} ref={latitudereference} placeholder="Latitude" name={latitudename} value={latitudevalue} onChange={callback} />
                <input type="input" maxlength="50" class="form-control" id={longitudename} ref={longitudereference}  placeholder="Longitude" name={longitudename} value={longitudevalue} onChange={callback} />
            </div>
        </>
    );
}

export function LocationCoordinates2({cityname, citytitle, cityreference, cityvalue, 
    coordinatesname,coordinatestitle, longitudename, latitudename, 
    longitudevalue, latitudevalue, callback, callbacklocation}) {
    const [data, setData] = useState([]);
    
    var callCommand=(event)=>{
        callback(event);
        if(event.target.value.length<3) {
            setData([]);
            onInput(event,[]);
        } else {
            axiosGetWithHeader("/search/coordinate/"+event.target.value, 
            (response)=>{
                onInput(event, response.data);
                setTimeout(() => {
                    setData(response.data);
                }, 100);
            },
            (error)=>{
                setData([]);
                onInput(event,[]);
            }
          );
          GLOBAL.isLoading=false;
        }
    }

    var onInput=(event,data)=> {
        var val=event.target.value;
        var flag="false";
        data.map((option) => {
           if(option.locationName===val) {
                callbacklocation(longitudename,option.longitude.trim());
                callbacklocation(latitudename,option.latitude.trim());
                flag="true";
           }
           return null;
        });
        if(flag==="false"){
            callbacklocation(longitudename,'');
            callbacklocation(latitudename,'');
        }
    }
    return (
        <>
            <div class="mb-0 mt-1">
                <label for={cityname}>{citytitle}: </label>
                <input type="input" class="form-control" list="citylist" id={cityname} ref={cityreference} placeholder={citytitle} name={cityname} value={cityvalue} onChange={callCommand}/>
                <datalist id="citylist" >
                    {data.map((option) => (
                    <option key={option.locationName} value={option.locationName}>{option.locationName}</option>
                    ))}
                </datalist>
                {cityvalue===null||cityvalue===undefined||cityvalue===''||latitudevalue===''||longitudevalue===''?<></>:
                  <center>
                    <label for={cityname}>Latitude  : <DoubleToDegree value={latitudevalue} /> </label>&nbsp;&nbsp;
                    <label for={cityname}>Longitude : <DoubleToDegree value={longitudevalue}/> </label>
                  </center>
                }
            </div>

            <div class="input-group mb-3 "> 
                <input type="hidden" maxlength="50" class="form-control" id={latitudename} placeholder="Latitude" name={latitudename} value={latitudevalue}  />
                <input type="hidden" maxlength="50" class="form-control" id={longitudename} placeholder="Longitude" name={longitudename} value={longitudevalue}  />
            </div>
        </>
    );
}

export function SubmitClearButton({callback}) {
    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            {
                GLOBAL.isLoading===true?(
                <>
                    <button type="submit" class="btn btn-primary " disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Submit
                    </button>
                    <button type="button" class="btn btn-primary " onClick={callback} disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Clear
                    </button>
                </>
                ):(
                <>
                    <button type="submit" class="btn btn-primary " >Submit</button>
                    <button type="button" class="btn btn-primary " onClick={callback}>Clear</button>
                </>
                )
            }
        </div>
    );
}

export function SubmitResetClearButton({callback,callbackReset}) {
    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            {
            GLOBAL.isLoading===true?(
            <>
            <button type="submit" class="btn btn-primary ">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Submit
            </button>
            <button type="button" class="btn btn-primary " onClick={callbackReset}>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Reset
            </button>
            <button type="button" class="btn btn-primary " onClick={callback}>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Clear
            </button>

            </>
            ):(
            <>
            <button type="submit" class="btn btn-primary ">Submit</button>
            <button type="button" class="btn btn-primary " onClick={callbackReset}>Reset</button>
            <button type="button" class="btn btn-primary " onClick={callback}>Clear</button>
            </>
            )
            }
        </div>
    );
}

export function DeleteCancelButton({callback, callbackCancel}) {
    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            {
                GLOBAL.isLoading===true?(
                <>
                    <button type="button" class="btn btn-primary " onClick={callback} disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Delete
                    </button>
                    <button type="button" class="btn btn-primary " onClick={callbackCancel} disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Cancel
                    </button>
                </>
                ):(
                <>
                    <button type="button" class="btn btn-primary " onClick={callback}>Delete</button>
                    <button type="button" class="btn btn-primary " onClick={callbackCancel}>Cancel</button>
                </>
                )
            }
        </div>
    );
}

export function SubmitResetButton({callback}) {
    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            {
                GLOBAL.isLoading===true?(
                <>
                    <button type="submit" class="btn btn-primary " disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Submit
                    </button>
                    <button type="button" class="btn btn-primary " onClick={callback} disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Reset
                    </button>
                </>
                ):(
                <>
                    <button type="submit" class="btn btn-primary " >Submit</button>
                    <button type="button" class="btn btn-primary " onClick={callback}>Reset</button>
                </>
                )
            }
        </div>
    );
}

export function SubmitResetButton1({callback}) {
    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            <button type="submit" class="btn btn-primary " >Submit</button>
            <button type="button" class="btn btn-primary " onClick={callback}>Reset</button>
        </div>
    );
}

export function SubmitResetGenerateButton({callback,callbackGenerate}) {
    return (
        <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
            <button type="submit" class="btn btn-primary " >Submit</button>
            <button type="button" class="btn btn-primary " onClick={callback}>Reset</button>
            <button type="button" class="btn btn-primary " onClick={callbackGenerate}>Generate</button>
        </div>
    );
}
